import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import initialState from '../initialState';
import IPlainPartExchange from '../../../common/model/IPlainPartExchange';

const partExchangeReducer = createSlice({
  name: 'PartExchangeReducer',
  initialState: initialState.partExchangeInitialState,
  reducers: {
    setPartExchange: (state, { payload }: PayloadAction<IPlainPartExchange | null>) => {
      state.partExchange = payload;
      state.loading = false;
    },
    setPartExchangeValuation: (state, { payload: pxValuation }: PayloadAction<number>) => {
      state.partExchangeValuation = pxValuation;
    },
  },
});

export const partExchangeActions = partExchangeReducer.actions;

export default partExchangeReducer.reducer;
